import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../boot";
import axios from "axios";

export const getUserList = createAsyncThunk('/thunk/get-user-list', async ()=>{
    try {
        const response = await axios.post(`${baseUrl}cleaningappfunctions/utils/app/v1/get-user-list`,{page:1})
        return response.data;
    } catch (error) {
        throw error
    }
})
